import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../_Sections/SectionDetails';
import SectionGallery from '../_Sections/SectionGallery';
import SectionDropship from '../_Sections/SectionDropship';
import SectionPairings from '../_Sections/SectionPairings';
import SectionBranding from '../_Sections/SectionBranding';
import SectionSizes from '../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../_Sections/SectionPricing';
import tKey from '../../Common/Utils/tKey';
import { useAppSelector } from '../../Common/_hooks/useAppSelector';
import ProductSEO from '../_Sections/ProductSEO';

const PRODUCT_ID = 27;
const VIEW_PRODUCT_ID = 31;

export default function BabyLeggingsPage() {
  const [t] = useTranslation('page/products/baby-leggings');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Baby Leggings | Products')}
      description={t('Design and create your own custom printed Baby Leggings featuring your artwork. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#ebabd5"
      bgStyle={{
        backgroundPosition: 'top right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '47%',
      }}
      tag={t('The all-over print')}
      title={t('Baby Leggings')}
      text={t('Keep your little one cozy in custom all-over print baby leggings made on-demand in Montreal. Made from ultrasoft Luxeform fabric and comfy foldover waistband, these full-length leggings are comfy for crawlers, snugglers, and explorers. Vibrant prints stay bright, wash after wash.')}
      createUrl={productData.get('url_slug')}
      img={require('@resources/img/pages/products/baby-leggings/banner-1-' + locale + '.png')}
      alt={t('Picture of Baby Leggings')}
      details={[
        {
          img: require('@resources/img/pages/products/baby-leggings/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Classic fit with foldover elastic waistband.'),
        },
        {
          img: require('@resources/img/pages/products/baby-leggings/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/baby-leggings/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Full length and available in sizing from 6 months to 3 years old'),
        },
        {
          img: require('@resources/img/pages/products/baby-leggings/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/baby-leggings/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    <SectionGallery images={[
      require('@resources/img/pages/products/baby-leggings/gallery_0.jpg'),
      require('@resources/img/pages/products/baby-leggings/gallery_1.jpg'),
      require('@resources/img/pages/products/baby-leggings/gallery_2.jpg'),
      require('@resources/img/pages/products/baby-leggings/gallery_3.jpg'),
      require('@resources/img/pages/products/baby-leggings/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your Baby <br/>Leggings <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Baby Leggings! At prices designed for reselling, Baby Leggings made on demand meet the needs of sellers who prefer not to stock inventory.. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing productId={PRODUCT_ID} />

    <SectionSizes
      productId={PRODUCT_ID}
      title={t('Baby Leggings Sizing')}
      text={t('There may be some variations in product measurements within or between orders. Each garment is individually cut and sewn which can lead to minor differences in measurements. In order : 6 months, 1 year, 2 years, 3 years')}
    >
      <img
        src={require('@resources/img/pages/products/baby-leggings/6m.png')}
        style={{
          marginRight: 0,
        }}
      />
      <img
        src={require('@resources/img/pages/products/baby-leggings/1y.png')}
        style={{
          marginRight: 0,
        }}
      />
      <img
        src={require('@resources/img/pages/products/baby-leggings/2y.png')}
        style={{
          marginRight: 0,
        }}
      />
      <img
        src={require('@resources/img/pages/products/baby-leggings/3y.png')}
        style={{
          marginRight: 0,
        }}
      />
    </SectionSizes>

    <SectionBranding
      hasLabel
      title={t('Brand your Baby Leggings')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Baby Leggings with these great products to create your own unique styles.')}
      productSlugs={['beanies-youth', 'youth-leggings', 'headband']}
    />
  </div>
}